// extracted by mini-css-extract-plugin
export default {"editRow":"style_editRow__rCBZw","tableBorder":"style_tableBorder__3Roly"};